/* eslint-disable import/prefer-default-export */
import styled, { css } from "styled-components";

export const WIDTHS = {
  values: ["sm", "md", "lg", "x-lg"],
  widths: {
    sm: 300,
    md: 550,
    lg: 800,
    "x-lg": 1080,
    fill: "auto"
  }
};

const verticalMargin = 30;

const dialogHeight = ({ heightValue }) => {
  if (typeof heightValue === "number") {
    return `${heightValue}px`;
  }

  return "auto";
};

const maxDimensions = css`calc(100% - ${verticalMargin * 2}px)`;

const getWidth = width => {
  if (width === "fill") {
    return "calc(100% - 1rem)";
  }
  return `${width}px`;
};

/**
  NOTE:
  absolute + top
  - rather than fixed position so popper.js children are properly positioned

  overflow-y
  - only active when popper.js children envoked below the dialog
*/
export const FillScreen = styled.div`
  z-index: 200;
  height: 100%;
  left: 0;
  overflow-y: auto;
  position: absolute;
  top: 0;
  width: 100%;
  -webkit-overflow-scrolling: touch;
`;

export const ModalDialog = styled.div`
  background-color: rgb(255, 255, 255);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  height: ${dialogHeight};
  max-height: 100%;
  width: ${props => props.width}px;
  /* Prevents buttons overflowing when squashing the modal vertically. */
  overflow-y: auto;
  @media (max-width: ${props => getWidth(props.width)}) {
    max-width: 95vw;
  }
`;

// Absolute positioner - for use when the modal's body content is scrollable.
export const PositionerAbsolute = styled.div`
  display: flex;
  flex-direction: column;
  height: ${maxDimensions};
  left: 0;
  margin-left: auto;
  margin-right: auto;
  max-height: calc(100% - 1px);
  max-width: ${maxDimensions};
  position: absolute;
  right: 0;
  top: ${verticalMargin}px;
  width: ${props => getWidth(props.width)};
  z-index: 300;
  @media (max-width: ${props => getWidth(props.width)}) {
    max-width: 95vw;
  }
`;

// Relative positioner - for use when the modal's body scrolls with the window.
export const PositionerRelative = styled.div`
  margin: ${verticalMargin}px auto;
  position: relative;
  width: ${props => getWidth(props.width)};
  z-index: 300;
  @media (max-width: ${props => getWidth(props.width)}) {
    max-width: 95vw;
  }
`;
